module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside_hvid_1.62d47012.svg";